import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ErrorDialog(props) {
  const [open, setOpen] = React.useState(true);
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const errorMessage = props.errorMessage;
  var onDismiss = props.onDismiss;

  const handleClose = () => {
    onDismiss();
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"We're having trouble processing your request"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            There was an issue completing your form. The form was not submitted. Please try again later. If this issue continues, please check the FAQ section for how to submit a paper form.
          </DialogContentText>
          <DialogContentText>
            {errorMessage}
          </DialogContentText>
        </DialogContent> 
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}